import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowGetInsurancesBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetInsurances),
    config: z.object({}), // there are no configs for this block
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Insurances),
});
//# sourceMappingURL=config.js.map